<script>
import "@/design/app.scss";
import Observer from 'vue-intersection-observer'
export default {
    components: { Observer},
    data() {
        return {
            tableData: [],
            errorMessage: null,
            currentPage: 1,
            perPage: 10,
            campuses: [],
            publicModal: {},
            showDiv: false,
            showImg: false,
            archives: [],
            archiveGroup: [],
            logoObserved: false,
            btnObserved: false,
            postsObserved: false,
            showPublicBidding: true,
            showSVP: true,
            publicBidding: [],
            svps: [],
            activePosts: [],
            showPublicBiddingTab: false,
            showSVPTab: false,
            selectedPBPost: null,
            selectedSVPPost: null,
            setTimeoutInt: 10,
            selectFilter: 'Active',
            showLoading: false,
            filterPB: '',
            searchPB: '',
            filterSVP: '',
            searchSVP: '',
            withNewLogo: window.WITH_NEW_LOGO,
            agencyName: window.AGENCY_NAME,
        };
    },
    computed: {
        rows() {
            return this.tableData.length;
        },
        filteredPublicBidding() {
            let data = this.publicBidding;
            if (this.filterPB.trim() != "" && this.filterPB) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filterPB.toUpperCase());
                });
            }
            return data;
        },
        filteredSVP() {
            let data = this.svps;
            if (this.filterSVP.trim() != "" && this.filterSVP) {
                data = data.filter((item) => {
                    return item.filterKey
                        .toUpperCase()
                        .includes(this.filterSVP.toUpperCase());
                });
            }
            return data;
        },
    },
    created(){
        document.body.style.backgroundColor = "#f5f5f5";
    },
    mounted() {
        this.$store
            .dispatch("campus/GetPublicCampus")
            .then((res) => {
                this.campuses = res.data;
            })
            .catch((err) => {
                this.errorMessage = "Something went wrong!";
            });
        this.getActivePosts();
        if(window.location.href.includes('#posts') || this.$route.params.id){
            this.$nextTick(() => {
                this.goto('posts');
                if(this.$route.params.type === 'public-bidding'){
                    this.showPublicBiddingTab = true;
                    this.showSVPTab = false;
                }else{
                    this.showPublicBiddingTab = false;
                    this.showSVPTab = true;
                }
                this.showSinglePost(this.$route.params.id, this.$route.params.type);
            })
        }
    },
    methods: {
        async getActivePosts() {
            this.showLoading = true;
            await this.$store
                .dispatch("publicpostedrfq/GetActivePublicPostRfq")
                .then((res) => {
                    this.publicBidding = [];
                    this.svps = [];
                    // console.log(res.data);
                    res.data.map((item) => {
                        let totalRFQ = 0;
                        item.rfq.rfqItems.map(x => {
                            totalRFQ += x.prItem.total;
                        })
                        item.totalABC = totalRFQ;
                        item.rfqPostingFiles = [];
                        item.fileLoading = false;
                        item.filterKey = `${item.rfq.description} ${item.rfq.rfqNumber}`
                        if(item.type === 'public-bidding'){
                            this.publicBidding.push(item);
                        }else{
                            this.svps.push(item);
                        }
                    });
                })
                .catch((err) => {
                    this.errorMessage = "Something went wrong!";
                });
            this.showLoading = false;
        },
        async getArchivePosts() {
            this.showLoading = true;
            await this.$store
                .dispatch("publicpostedrfq/GetArchivePublicPostRfq")
                .then((res) => {
                    this.publicBidding = [];
                    this.svps = [];
                    res.data.map((item) => {
                        let totalRFQ = 0;
                        item.rfq.rfqItems.map(x => {
                            totalRFQ += x.prItem.total;
                        })
                        item.totalABC = totalRFQ;
                        item.rfqPostingFiles = [];
                        item.fileLoading = false;
                        if(item.type === 'public-bidding'){
                            this.publicBidding.push(item);
                        }else{
                            this.svps.push(item);
                        }
                    });
                })
                .catch((err) => {
                    this.errorMessage = "Something went wrong!";
                });
            this.showLoading = false;
        },
        goto(refName) {
            var element = this.$refs[refName];
            var top = element.offsetTop - 90;
            window.scrollTo(0, top);
        },
        async getAttachedFiles(row) {
            row.fileLoading = true;
            await this.$store
                .dispatch("rfqpostingfile/GetRfqPostingFiles", row.id)
                .then(async(res) => {
                    row.rfqPostingFiles = res.data;
                })
                .catch(() => {
                    this.showToast("Something went wrong!", "error");
                });
            row.fileLoading = false;
        },
        openFile(x) {
            window.open(
                `${this.$store.state.data.rootFileDirectory}Procurement/${x.fileName}`
            );
        },
        goToLogin(){
            window.open(`/login`, "_self");
        },
        getPad(x){
            if(x < 10){
                return "0" + x;
            }else{
                return x;
            }
        },
        onScrollLogo(entry, obv){
            this.logoObserved = !entry.isIntersecting ? true : false;
        },
        onScrollBtn(entry, obv){
            this.btnObserved = !entry.isIntersecting ? true : false;
        },
        onScrollPosts(entry, obv){
            if(entry.isIntersecting){
                this.postsObserved = true;
                obv();
            }
        },
        viewPost(post, type){
            if(type === 'public-bidding'){
                this.selectedPBPost = post;
                this.selectedSVPPost = null;
                this.showPublicBiddingTab = true;
                this.showSVPTab = false;
            }else{
                this.selectedPBPost = null;
                this.selectedSVPPost = post;
                this.showPublicBiddingTab = false;
                this.showSVPTab = true;
            }
            if(post.id == this.$route.params.id){
                return;
            }
            this.$router.replace({name: 'public-posts', params: { type: type, id: post.id }});
            this.$nextTick(() => {
                setTimeout(() => {
                    this.goto('posts');
                    this.getAttachedFiles(post);
                }, this.setTimeoutInt);
            })
        },
        async showSinglePost(id, type){
            this.selectedPBPost = null;
            this.selectedSVPPost = null;
            if(type === 'public-bidding'){
                this.showPublicBiddingTab = true;
                this.showSVPTab = false;
            }else{
                this.showPublicBiddingTab = false;
                this.showSVPTab = true;
            }
            await this.getSinglePost(id, type);
        },
        async getSinglePost(id, type){
            await this.$store
                .dispatch("publicpostedrfq/GetSinglePublicPostRfq", id)
                .then((res) => {
                    let totalRFQ = 0;
                    res.data.rfq.rfqItems.map(x => {
                        totalRFQ += x.prItem.total;
                    })
                    res.data.totalABC = totalRFQ;
                    res.data.rfqPostingFiles = [];
                    res.data.fileLoading = false;
                    if(type === 'public-bidding'){
                        this.selectedPBPost = res.data;
                    }else{
                        this.selectedSVPPost = res.data;
                    }
                    this.getAttachedFiles(res.data);
                })
                .catch((err) => {
                    this.showToast("Something went wrong!", "error")
                });
        },
        returnBack(type){
            if(type === 'public-bidding'){
                this.showPublicBiddingTab = true;
                this.showSVPTab = false;
                this.selectedPBPost = null;
            }else{
                this.showPublicBiddingTab = false;
                this.showSVPTab = true;
                this.selectedSVPPost = null;
            }
            this.$router.replace({name: 'public-posts', params: { type: type, id: null }});
            this.$nextTick(() => {
                setTimeout(() => {
                    this.goto('posts');
                }, this.setTimeoutInt);
            })
        },
        goToHome(){
            this.showPublicBiddingTab = false;
            this.showSVPTab = false;
            this.selectedPBPost = null;
            this.selectedSVPPost = null;
            this.$router.replace({name: 'public-posts', params: { type: null, id: null }});
            this.$nextTick(() => {
                setTimeout(() => {
                    this.goto('posts');
                }, this.setTimeoutInt);
            })
        },
        goToPublicBidding(){
            this.showPublicBiddingTab = true;
            this.showSVPTab = false;
            if(this.$route.params.type !== 'public-bidding'){
                this.$router.replace({name: 'public-posts', params: { type: 'public-bidding', id: null }});
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    this.goto('posts');
                }, this.setTimeoutInt);
            })
        },
        goToSVP(){
            this.showPublicBiddingTab = false;
            this.showSVPTab = true;
            if(this.$route.params.type !== 'svp'){
                this.$router.replace({name: 'public-posts', params: { type: 'svp', id: null }});
            }
            this.$nextTick(() => {
                setTimeout(() => {
                    this.goto('posts');
                }, this.setTimeoutInt);
            })
        },
        changeFilter(){
            if(this.selectFilter === 'Active'){
                this.getActivePosts();
            }else{
                this.getArchivePosts();
            }
        },
        openDocument(x) {
            this.readFile(x.id)
        },
        async downloadSVPFile({rfqPostingFiles}){
            if(rfqPostingFiles.length == 0){
                return this.showToast("No file to download!", "error");
            }
            for await(const item of rfqPostingFiles){
                if(item.files.length > 0){
                    this.readFile(item.files[0].id);
                    // window.open(
                    //     `${this.$store.state.data.rootFileDirectory}Procurement/${item.files[0].fileName}`
                    // );
                }
                await this.wait(1000);
            }
        },
        searchForSVP(){
            this.filterSVP = this.deepClone(this.searchSVP);
        },
        searchForPB(){
            this.filterPB = this.deepClone(this.searchPB);
        },
    },
};
</script>
<template>
    <div class="public-post">
        <nav class="observed-nav" :class="{'d-none': !logoObserved}"></nav>
        <div class="d-flex justify-content-center align-items-center position-relative whole-screen-hidden" >
            <div class="position-absolute circle-1">
                <div class="position-relative rotate-n-45">
                    <div class="position-relative circle-transparent">
                        <div class="position-absolute line-orange line-1"></div>
                        <div class="position-absolute line-orange line-2"></div>
                        <div class="position-absolute line-orange line-3"></div>
                        <div class="position-absolute line-orange line-4"></div>
                        <div class="position-absolute line-orange line-5"></div>
                        <div class="position-absolute line-orange line-6"></div>
                        <div class="position-absolute line-orange line-7"></div>
                        <div class="position-absolute line-orange line-8"></div>
                        <div class="position-absolute line-orange line-9"></div>
                    </div>
                    <div class="position-absolute circle-grey">
                        <div class="position-relative circle-transparent">
                            <div class="position-absolute line-grey line-1 h-30px"></div>
                            <div class="position-absolute line-grey line-2"></div>
                            <div class="position-absolute line-grey line-3"></div>
                            <div class="position-absolute line-grey line-4"></div>
                            <div class="position-absolute line-grey line-5"></div>
                            <div class="position-absolute line-grey line-6"></div>
                            <div class="position-absolute line-grey line-7"></div>
                            <div class="position-absolute line-grey line-8"></div>
                            <div class="position-absolute line-grey line-9"></div>
                            <div class="position-absolute line-grey line-10"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="position-absolute circle-2">
                <div class="position-relative rotate-p-45">
                    <div class="position-relative circle-transparent">
                        <div class="position-absolute line-orange line-1"></div>
                        <div class="position-absolute line-orange line-2"></div>
                        <div class="position-absolute line-orange line-3"></div>
                        <div class="position-absolute line-orange line-4"></div>
                        <div class="position-absolute line-orange line-5"></div>
                        <div class="position-absolute line-orange line-6"></div>
                        <div class="position-absolute line-orange line-7"></div>
                        <div class="position-absolute line-orange line-8"></div>
                        <div class="position-absolute line-orange line-9"></div>
                    </div>
                    <div class="position-absolute circle-grey">
                        <div class="position-relative circle-transparent">
                            <div class="position-absolute line-grey line-1 h-30px"></div>
                            <div class="position-absolute line-grey line-2"></div>
                            <div class="position-absolute line-grey line-3"></div>
                            <div class="position-absolute line-grey line-4"></div>
                            <div class="position-absolute line-grey line-5"></div>
                            <div class="position-absolute line-grey line-6"></div>
                            <div class="position-absolute line-grey line-7"></div>
                            <div class="position-absolute line-grey line-8"></div>
                            <div class="position-absolute line-grey line-9"></div>
                            <div class="position-absolute line-grey line-10"></div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="position-absolute circle-3">
                <div class="position-relative circle-orange"></div>
            </div>
            <div class="text-center">
                <observer @on-change="onScrollLogo">
                    <div :class="{'logo-observed': logoObserved}" class="d-flex align-items-baseline justify-content-center">
                        <img src="@/assets/images/ustp-blue-logo.png" alt="USTP Logo" class="img-ustp-height" :class="{'me-5': !logoObserved && !withNewLogo, 'me-2': logoObserved || withNewLogo}" >
                        <div class="position-relative d-flex me-4" v-if="withNewLogo">
                            <img :src="`${agencyName}-logo.png`" :alt="`${agencyName.toUpperCase()} LOGO`" class="other-logo-width">
                            <!-- </div> -->
                        </div>
                        <img src="@/assets/images/logo/giams-colored.png" alt="GIAMS LOGO" class="img-giams-width">
                    </div>
                    
                </observer>
                <div class="text-center mt-5 px-2">
                    <h1 class="giams-label">GOVERNMENT INTEGRATED ADMINISTRATIVE MANAGEMENT SYSTEM</h1>
                </div>
                <div class="mt-5 d-flex justify-content-center">
                    <button type="button" class="btn-orange-outline me-3 d-flex px-3" @click="goto('posts')">
                        Show Public Posts <i class="mdi mdi-chevron-down"></i>
                    </button>
                    <observer @on-change="onScrollBtn">
                        <button type="button" class="btn-orange-outline" :class="{'btn-login-observed px-3': btnObserved}" @click="goToLogin">
                            <i class="mdi mdi-login-variant"></i> Login
                        </button>
                    </observer>
                </div>
            </div>
        </div>
        <observer @on-change="onScrollPosts" :threshold=[0.4]>
            <div style="min-height:100vh;" ref="posts" id="posts">
                <b-tabs nav-class="nav-tabs-custom" content-class="text-muted" class="tab-blue">
                <b-tab active @click="goToHome">
                    <template v-slot:title>
                    <span class="d-inline-block d-sm-none">
                        <i class="fas fa-home"></i>
                    </span>
                    <span class="d-none d-sm-inline-block">HOME</span>
                    </template>
                    <div class="container">
                        <div class="page-title text-center my-4">
                            <div class="row">
                                <div class="offset-md-4 col-md-4 text-center">
                                    <h1> Bids and Awards</h1>
                                </div>
                                <div class="col-md-4">
                                    <div class="d-flex justify-content-end">
                                        <select class="form-select max-width-200" v-model="selectFilter" @change="changeFilter">
                                            <option value="Active">Active</option>
                                            <option value="Archive">Archive</option>
                                        </select>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="card mb-4">
                            <div class="card-header bg-teal font-size-16 d-flex align-items-center justify-content-between">
                                <div>
                                    <i class="bx bx-copy me-1"></i>Public Bidding
                                </div>
                                <div class="d-flex align-items-center">
                                    <i class="bx bx-chevron-right font-size-22 cursor-pointer rotate" :class="{'rotate-90': showPublicBidding}" @click="showPublicBidding = !showPublicBidding"></i>
                                    <i class="bx bx-refresh font-size-22 cursor-pointer"></i>
                                </div>
                            </div>
                            <b-collapse
                                :visible="showPublicBidding"
                                :accordion="`public-bidding`"
                                role="tabpanel"
                            >
                                <div class="card-body">
                                    <table class="table table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th scope="col">Project Title</th>
                                                <th scope="col" style="width:120px;">Posted On</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="!showLoading && publicBidding.length == 0">
                                                <tr>
                                                    <td colspan="2" class="text-center">No data available</td>
                                                </tr>
                                            </template>
                                            <template v-if="showLoading">
                                                <tr>
                                                    <td colspan="2" class="text-center">
                                                        <div class="d-flex justify-content-center align-items-center">
                                                            <div class="preloader-component me-2">
                                                                <div class="status">
                                                                    <div class="spinner-chase w-20px h-20px">
                                                                        <div class="chase-dot"></div>
                                                                        <div class="chase-dot"></div>
                                                                        <div class="chase-dot"></div>
                                                                        <div class="chase-dot"></div>
                                                                        <div class="chase-dot"></div>
                                                                        <div class="chase-dot"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <strong>Loading...</strong>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                            <template v-if="!showLoading && publicBidding.length > 0">
                                                <tr v-for="post in publicBidding" :key="post.id">
                                                    <td>
                                                        <a href="javascript:void(0);" @click="viewPost(post, 'public-bidding')" class="hoverable-link">
                                                            {{post.rfq.rfqNumber}}-{{ post.rfq.description }}
                                                        </a>
                                                    </td>
                                                    <td>{{ formatDateCustom(new Date(post.datePublish)) }}</td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </b-collapse>
                        </div>
                        <div class="card">
                            <div class="card-header bg-skyblue font-size-16 d-flex align-items-center justify-content-between">
                                <div>
                                    <i class="bx bx-copy me-1"></i>Small Value Procurement
                                </div>
                                <div class="d-flex align-items-center">
                                    <i class="bx bx-chevron-right font-size-22 cursor-pointer rotate" :class="{'rotate-90': showSVP}" @click="showSVP = !showSVP"></i>
                                    <i class="bx bx-refresh font-size-22 cursor-pointer"></i>
                                </div>
                            </div>
                            <b-collapse
                                :visible="showSVP"
                                :accordion="`svp`"
                                role="tabpanel"
                            >
                                <div class="card-body">
                                    <table class="table table-striped table-hover">
                                        <thead>
                                            <tr>
                                                <th scope="col">Project Title</th>
                                                <th scope="col" style="width:120px;">Posted On</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            <template v-if="!showLoading && svps.length == 0">
                                                <tr>
                                                    <td colspan="2" class="text-center">No data available</td>
                                                </tr>
                                            </template>
                                            <template v-if="showLoading">
                                                <tr>
                                                    <td colspan="2" class="text-center">
                                                        <div class="d-flex justify-content-center align-items-center">
                                                            <div class="preloader-component me-2">
                                                                <div class="status">
                                                                    <div class="spinner-chase w-20px h-20px">
                                                                        <div class="chase-dot"></div>
                                                                        <div class="chase-dot"></div>
                                                                        <div class="chase-dot"></div>
                                                                        <div class="chase-dot"></div>
                                                                        <div class="chase-dot"></div>
                                                                        <div class="chase-dot"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <strong>Loading...</strong>
                                                        </div>
                                                    </td>
                                                </tr>
                                            </template>
                                            <template v-if="!showLoading && svps.length > 0">
                                                <tr v-for="post in svps" :key="post.id">
                                                    <td>
                                                        <a href="javascript:void(0);" @click="viewPost(post, 'svp')" class="hoverable-link">
                                                            {{post.rfq.rfqNumber}}-{{ post.rfq.description }}
                                                        </a>
                                                    </td>
                                                    <td>{{ formatDateCustom(new Date(post.datePublish)) }}</td>
                                                </tr>
                                            </template>
                                        </tbody>
                                    </table>
                                </div>
                            </b-collapse>
                        </div>
                    </div>
                </b-tab>
                <b-tab :active="showPublicBiddingTab" @click="goToPublicBidding">
                    <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                            <i class="fas fa-file-invoice"></i>
                        </span>
                        <span class="d-none d-sm-inline-block">PUBLIC BIDDING</span>
                    </template>
                    <div class="container">
                        <div class="card my-0" v-if="!selectedPBPost">
                            <div class="card-body p-0">
                                <div class="my-5 px-4">
                                    <form @submit.prevent="searchForPB">
                                        <b-input-group>
                                            <template #append>
                                                <button class="btn btn-teal btn-lg">Search</button>
                                            </template>
                                            <input type="text" class="form-control form-control-lg bg-secondary bg-soft" placeholder="Search for..." v-model="searchPB">
                                        </b-input-group>
                                    </form>
                                </div>
                                <hr>
                                <div class="px-4">
                                    <div class="card border">
                                        <div class="card-header bg-teal">
                                            <h3 class="mb-0 text-white text-center">Public Bidding for Major Projects</h3>
                                        </div>
                                        <div class="card-body p-0" v-if="filteredPublicBidding.length > 0">
                                            <div class="ps-5 d-flex justify-content-between align-items-center hover-secondary" v-for="pb in filteredPublicBidding" :key="pb.id">
                                                <div>
                                                    <div class="uppercase mt-3 mb-2 text-teal font-size-15">
                                                        <b>{{formatDate(new Date(pb.datePublish))}}</b>
                                                    </div>
                                                    <div class="mb-5">
                                                        <a href="javascript:void(0);" class="hover-underline font-size-15" @click="viewPost(pb, 'public-bidding')">{{pb.rfq.rfqNumber.toUpperCase()}}-{{pb.rfq.description.toUpperCase()}}</a>
                                                    </div>
                                                </div>
                                                <div class="px-3">
                                                    <i class="bx bx-chevron-right font-size-22"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="publicBidding.length == 0" class="text-center my-3">
                                            <h5>No data found.</h5>
                                        </div>
                                        <div v-if="publicBidding.length > 0 && filteredPublicBidding.length == 0" class="text-center my-3">
                                            <h5>Search not found.</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="px-2 py-5">
                            <div class="d-flex justify-content-between align-items-center">
                                <button class="btn btn-teal" @click="returnBack('public-bidding')"><i class="bx bx-left-top-arrow-circle"></i> Back</button>
                                <h3 class="mb-0 text-black">Public Bidding</h3>
                            </div>
                            <div class="mt-4">
                                <div class="card border">
                                    <div class="card-header bg-teal">
                                        <p class="text-white mb-0 font-size-18">{{selectedPBPost.rfq.rfqNumber}}-{{selectedPBPost.rfq.description}}</p>
                                    </div>
                                    <div class="card-body">
                                        <div class="row mb-2">
                                            <div class="col-md-6 text-black">
                                                Contract No:
                                            </div>
                                            <div class="col-md-6 text-black">
                                                <b>N/A</b>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-6 text-black">
                                                Bid Opening: 
                                            </div>
                                            <div class="col-md-6 text-black">
                                                <b>{{formatDateCustom(new Date())}}</b>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-6 text-black">
                                                Pre Bid Conference:
                                            </div>
                                            <div class="col-md-6 text-black">
                                                <b>{{formatDateCustom(new Date())}}</b>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-6 text-black">
                                                Approved Budget for the Contract:
                                            </div>
                                            <div class="col-md-6 text-black">
                                                <b>{{formatCurrency(selectedPBPost.totalABC)}}</b>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-6 text-black">
                                                Non Refundable Bidder Fee:
                                            </div>
                                            <div class="col-md-6 text-black">
                                                <b>{{formatCurrency(selectedPBPost.nonRefundableBidderFee)}}</b>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-6 text-black">
                                                Delivery Period:
                                            </div>
                                            <div class="col-md-6 text-black">
                                                <b>{{selectedPBPost.pr.deliveryPeriod}} Day/s</b>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-4">
                                <div class="card border">
                                    <div class="card-header bg-teal">
                                        <p class="text-white mb-0 font-size-16"><i class="mdi mdi-cogs"></i> Bid Notices</p>
                                    </div>
                                    <div class="card-body">
                                        <table class="table table-bordered">
                                            <thead>
                                                <tr>
                                                    <th>Name of File</th>
                                                    <th width="150px">Posted On</th>
                                                    <th width="150px">Download Link</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                <tr v-if="!selectedPBPost.fileLoading && selectedPBPost.rfqPostingFiles.length == 0">
                                                    <td colspan="3" class="text-center">No data available</td>
                                                </tr>
                                                <tr v-if="selectedPBPost.fileLoading">
                                                    <td colspan="3" class="text-center">
                                                        <div class="d-flex justify-content-center align-items-center">
                                                            <div class="preloader-component me-2">
                                                                <div class="status">
                                                                    <div class="spinner-chase w-20px h-20px">
                                                                        <div class="chase-dot"></div>
                                                                        <div class="chase-dot"></div>
                                                                        <div class="chase-dot"></div>
                                                                        <div class="chase-dot"></div>
                                                                        <div class="chase-dot"></div>
                                                                        <div class="chase-dot"></div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <strong>Loading...</strong>
                                                        </div>
                                                    </td>
                                                </tr>
                                                <template v-if="!selectedPBPost.fileLoading && selectedPBPost.rfqPostingFiles.length > 0">
                                                    <tr v-for="file in selectedPBPost.rfqPostingFiles" :key="file.id">
                                                        <td class="align-middle">{{file.title}}</td>
                                                        <td class="align-middle">{{formatDateCustom(new Date(file.files[0].dateTimeUploaded))}}</td>
                                                        <td class="align-middle"><button type="button" class="btn btn-sm btn-teal" v-if="file.files.length > 0" @click="openDocument(file.files[0])">Download</button></td>
                                                    </tr>
                                                </template>
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-tab>
                <b-tab :active="showSVPTab" @click="goToSVP">
                    <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                            <i class="fas fa-file-contract"></i>
                        </span>
                        <span class="d-none d-sm-inline-block">SMALL VALUE PROCUREMENT</span>
                    </template>
                    <div class="container">
                        <div class="card my-0" v-if="!selectedSVPPost">
                            <div class="card-body p-0">
                                <div class="my-5 px-4">
                                    <form @submit.prevent="searchForSVP">
                                        <b-input-group>
                                            <template #append>
                                                <button type="submit" class="btn btn-skyblue btn-lg">Search</button>
                                            </template>
                                            <input type="text" class="form-control form-control-lg bg-secondary bg-soft" placeholder="Search for..." v-model="searchSVP">
                                        </b-input-group>
                                    </form>
                                </div>
                                <hr>
                                <div class="px-4">
                                    <div class="card border">
                                        <div class="card-header bg-skyblue">
                                            <h3 class="mb-0 text-white text-center">Request for Quotation for Small Value Procurement</h3>
                                        </div>
                                        <div class="card-body p-0" v-if="filteredSVP.length > 0">
                                            <div class="ps-5 d-flex justify-content-between align-items-center hover-secondary" v-for="svp in filteredSVP" :key="svp.id">
                                                <div>
                                                    <div class="uppercase mt-3 mb-2 text-skyblue font-size-15">
                                                        <b>{{formatDate(new Date(svp.datePublish))}}</b>
                                                    </div>
                                                    <div class="mb-5">
                                                        <a href="javascript:void(0);" class="hover-underline font-size-15" @click="viewPost(svp, 'svp')">{{svp.rfq.rfqNumber.toUpperCase()}}-{{svp.rfq.description.toUpperCase()}}</a>
                                                    </div>
                                                </div>
                                                <div class="px-3">
                                                    <i class="bx bx-chevron-right font-size-22"></i>
                                                </div>
                                            </div>
                                        </div>
                                        <div v-if="svps.length == 0" class="text-center my-3">
                                            <h5>No data found.</h5>
                                        </div>
                                        <div v-if="svps.length > 0 && filteredSVP.length == 0" class="text-center my-3">
                                            <h5>Search not found.</h5>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div v-else class="px-2 py-5">
                            <div class="d-flex justify-content-between align-items-center">
                                <button class="btn btn-skyblue" @click="returnBack('svp')"><i class="bx bx-left-top-arrow-circle"></i> Back</button>
                                <h3 class="mb-0 text-black">Small Value Procurement</h3>
                            </div>
                            <div class="mt-4">
                                <div class="card border">
                                    <div class="card-header bg-skyblue">
                                        <p class="text-white mb-0 font-size-18">{{selectedSVPPost.rfq.rfqNumber}}-{{selectedSVPPost.rfq.description}}</p>
                                    </div>
                                    <div class="card-body">
                                        <div class="row mb-2">
                                            <div class="col-md-6 text-black">
                                                Posted On:
                                            </div>
                                            <div class="col-md-6 text-black">
                                                <b>{{formatDateCustom(new Date(selectedSVPPost.datePublish))}}</b>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-6 text-black">
                                                Quotation No:
                                            </div>
                                            <div class="col-md-6 text-black">
                                                <b>{{selectedSVPPost.rfq.rfqNumber}}</b>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-6 text-black">
                                                Approved Budget for the Contract:
                                            </div>
                                            <div class="col-md-6 text-black">
                                                <b>{{formatCurrency(selectedSVPPost.totalABC)}}</b>
                                            </div>
                                        </div>
                                        <div class="row mb-2">
                                            <div class="col-md-6 text-black">
                                                Delivery Period:
                                            </div>
                                            <div class="col-md-6 text-black">
                                                <b>{{selectedSVPPost.pr.deliveryPeriod}} Day/s</b>
                                            </div>
                                        </div>
                                        <div class="mt-3 text-black">
                                            <b>For a copy of the full document, click the button below:</b>
                                        </div>
                                        <div class="mt-2">
                                            <a href="javascript:void(0);" class="btn btn-teal" @click="downloadSVPFile(selectedSVPPost)"><i class="bx bx-download"></i> Download</a>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </b-tab>
                <b-tab>
                    <template v-slot:title>
                        <span class="d-inline-block d-sm-none">
                            <i class="fa fa-info-circle"></i>
                        </span>
                        <span class="d-none d-sm-inline-block">CONTACT US</span>
                    </template>
                    <div class="container index-info my-5">
                        <div class="bg-blue px-4 py-3">
                            <h3 class="uppercase mt-3 mb-4">Need to know more?</h3>
                            <div class="c-line-left"></div>
                            <h3>For further information, please refer to:</h3>
                            <h3>Ms. Melanie A. Jalover</h3>
                            <p>Head, Procurement Services</p>
                            <p><i class="bx bx-map-alt"></i> University of Science and Technology of Southern Philippines, C.M Recto Ave. Lapasan Cagayan de Oro City</p>
                            <p><i class="bx bx-phone-call"></i> (088) 856 - 1738 Local 164</p>
                            <p><i class="bx bxs-paper-plane"></i> bacsec@ustp.edu.ph</p>
                            <p> <a href="http://cdo.ustp.edu.ph/" target="_blank" class="hover-underline text-white"> <i class="bx bx-globe"></i> cdo.ustp.edu.ph</a></p>
                        </div>
                    </div>
                </b-tab>
                </b-tabs>
            </div>
        </observer>
    </div>
</template>
<style>
.header-navigation {
    border-bottom: 1px solid #5959c2;
    background: #16163f;
}
.nav-link.custom-link {
    font-weight: 400;
    font-size: 14px;
}
.nav-link.active {
    font-weight: 600;
}
</style>